import React from 'react';
import './switchWithLabel.css';

const SwitchWithLabel = ({
  checked = false,
  onChange,
  disabled = false,
  label = null,
  helperText = null,
  variant = 'inline',
}) => {
  const handleToggle = () => {
    if (disabled) return;
    onChange && onChange(!checked);
  };

  const SwitchCore = () => (
    <button
      type='button'
      onClick={handleToggle}
      className={`switch-with-label 
        ${checked ? 'switch-with-label--active' : ''} 
        ${disabled ? 'switch-with-label--disabled' : ''}`}
    >
      <div className='switch-with-label__thumb' />
    </button>
  );

  if (variant === 'field') {
    return (
      <div className='switch-field'>
        {label && (
          <label className='switch-field__label mb-1 caption'>{label}</label>
        )}
        <div className='switch-field__control'>
          <SwitchCore />
          {helperText && (
            <span
              className='caption switch-field__text'
              style={{ color: !checked && 'var(--gray-600)' }}
            >
              {helperText}
            </span>
          )}
        </div>
      </div>
    );
  }

  if (label) {
    return (
      <div className='d-flex align-items-center'>
        <p className='caption me-2'>{label}</p>
        <SwitchCore />
      </div>
    );
  }

  return <SwitchCore />;
};

export default SwitchWithLabel;
